module.exports = __webpack_public_path__ + "images/temp2660affc63a39d4a201cae4f4ce9a7a76.png";